/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AuctionManagementListAuctionRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: AuctionManagementListAuctionRequest.direction | null;
    id?: number | null;
    name?: string | null;
    code?: string | null;
    status?: Array<string>;
    procedure?: Array<string>;
    kind?: Array<string>;
    size?: Array<string>;
    age?: Array<string>;
    sex?: Array<string>;
};

export namespace AuctionManagementListAuctionRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

